/**
 * Step5 Component: dove_posizione
 */

 import React, { Component } from 'react';

 import appStore from '../../../redux/store/appStore';
 import { updateGui, updateConfiguration } from '../../../redux/actions/actions';
 
 import Step from './Step';
 import HtmlSelect from '../../HtmlInput/HtmlSelect';
 
 import { stepEditingDataId2CoreId, nextPermissionDeniedGuiFeedback } from '../../../helpers/wizard-helper';
 
 import { getItem } from '../../../helpers/object-helper';
 
 import './Step4.css';
 
 class Step4 extends Component {
    constructor(props) {
        super(props);
        this.stepNum = props.stepNum;
        this.stepConf = props.stepConf;
        this.editingDataId = this.stepConf.dataId;
        this.stepText = this.stepConf.text;
        this.dataIds = this.stepConf.tableData.map(record => record.dataId); 
        this.options = this.stepConf.options;
        this.isValidated = this.isValidated.bind(this);
        this.onOptionChange = this.onOptionChange.bind(this);
        this.state = this.getInitialState(this.dataIds, this.options);
    }

    componentDidMount() {
        appStore.dispatch(
            updateGui({
                currentEditingData: this.editingDataId,
            })
        );
        
        this.updateState(this.getValuesFromStore());
    }

    /**
     * Returns the inital state
     * @param {Object[]} options
     *  [n]
     *      .label {String}
     *      .value {String}
     * @returns {Object}
     *  .numero_clima_per_stanza_mono9
     *      .selectedOptionId 
     *      .1..10 {Boolean}
     *  .numero_clima_per_stanza_mono12
     *      .selectedOptionId 
     *      .1..10 {Boolean}
     *  .numero_clima_per_stanza_mono18
     *      .selectedOptionId 
     *      .1..10 {Boolean}
     *  .numero_clima_per_stanza_dual9_9
     *      .selectedOptionId 
     *      .1..10 {Boolean}
     *  .numero_clima_per_stanza_dual9_12
     *      .selectedOptionId 
     *      .1..10 {Boolean}
     *  .numero_clima_per_stanza_trial9_9_9
     *      .selectedOptionId 
     *      .1..10 {Boolean}
     *  .numero_clima_per_stanza_trial9_9_12
     *      .selectedOptionId 
     *      .1..10 {Boolean}
     */
    getInitialState(dataIds, options) {
        const state = {};
        dataIds.forEach(dataId => {
            state[dataId] = {
                selectedOptionId: null,
            }
            options.forEach(option => {
                state[dataId][option.value] = false;
            });
        });
        return state;
    }

    /**
     * Updates component state
     * @param {Object} updateData
     *  .numero_clima_per_stanza_mono9
     *      .selectedOptionId
     *  .numero_clima_per_stanza_mono12
     *      .selectedOptionId
     *  .numero_clima_per_stanza_mono18
     *      .selectedOptionId
     *  .numero_clima_per_stanza_dual9_9
     *      .selectedOptionId
     *  .numero_clima_per_stanza_dual9_12
     *      .selectedOptionId
     *  .numero_clima_per_stanza_trial9_9_9
     *      .selectedOptionId
     *  .numero_clima_per_stanza_trial9_9_12
     *      .selectedOptionId
     */
    updateState(updateData) {

        const newState = this.getInitialState(this.dataIds, this.options);

        Object.keys(updateData).forEach(dataId => {
            const selectedOptionId = updateData[dataId];
            if (selectedOptionId) {
                newState[dataId] = {
                    ...newState[dataId],
                    [selectedOptionId]: true,
                    selectedOptionId
                }
            }
        });

        this.setState(() => newState);

    }

     /**
      * Step validation
      * @param {Boolean} showWarnMessage optional
      *  = undefined when call stack begins with btn next click, going through Stepzilla internals
      *      -> reacting to btn next click must show the warn message
      *  = Boolean (false) when call stack starts from Step.nextPermissionListener()
      *      -> reacting to redux store properties changes must not show the warn message
      */
     isValidated(showWarnMessage) {
         const data = this.getValuesFromStore();
         const valid = Object.entries(data).some(([entry, value]) => (value !== null));

         if (!valid && showWarnMessage === undefined) {
             nextPermissionDeniedGuiFeedback(this, this.stepNum, true);
         }

         return valid;
     }

    /**
     * Returns from the store the values of the piece of data related to this step
     * @return {Object} updateData
     *  .numero_clima_per_stanza_mono9 {Number|null}
     *  .numero_clima_per_stanza_mono12 {Number|null}
     *  .numero_clima_per_stanza_mono18 {Number|null}
     *  .numero_clima_per_stanza_dual9_9 {Number|null}
     *  .numero_clima_per_stanza_dual9_12 {Number|null}
     *  .numero_clima_per_stanza_trial9_9_9 {Number|null}
     *  .numero_clima_per_stanza_trial9_9_12 {Number|null}
     */
    getValuesFromStore() {
        return this.dataIds.reduce((acc, dataId) => {
            acc[dataId] = getItem(`configuration.${ dataId }`, appStore.getState());
            return acc;
        }, {});
    }

    /**
     * On change event listener for radio option
     */
    onOptionChange(evt) {
        const dataId = evt.target.getAttribute("id");
        let value = evt.target.value;
        if (value === '') {
            value = null;
        }

        this.updateState(dataId, value);

        appStore.dispatch(
            updateConfiguration({
                [dataId]: value,
            })
        );

        this.isValidated();
    }

     body() {
         return (
             <div
                 className={`slc-${stepEditingDataId2CoreId(
                     this.editingDataId
                 )}`}
             >
                <div className="slc-step-text--title">
                { this.stepText }
                </div>
                 <div className="slc-tbl-ncl">
                     <div className="slc-tbl-ncl-cell slc-tbl-ncl-header-nclima">
                         N. clima
                     </div>
                     <div className="slc-tbl-ncl-cell slc-tbl-ncl-header-label">
                         Climatizzatore
                     </div>
                     <div className="slc-tbl-ncl-cell slc-tbl-ncl-header-mq">
                         Mq complessivi
                     </div>
                     {this.stepConf.tableData.map((record) => (
                         <React.Fragment key={ record.dataId }>
                             <div className="slc-tbl-ncl-cell slc-tbl-ncl-body-n">
                                 N.
                             </div>
                             <div className="slc-tbl-ncl-cell slc-tbl-ncl-body-input">
                                 <HtmlSelect
                                     id={ record.dataId }
                                     className="slc-html-select"
                                     options={ this.options }
                                     value={ getItem(`configuration.${ record.dataId }`, appStore.getState()) }
                                     onChange={ this.onOptionChange }
                                 />
                             </div>
                             <div className="slc-tbl-ncl-cell slc-tbl-ncl-body-label">
                                 { record.label }
                             </div>
                             <div className="slc-tbl-ncl-cell slc-tbl-ncl-body-mq">
                                 { record.mq }
                             </div>
                         </React.Fragment>
                     ))}
                 </div>
             </div>
         );
     }

     render() {
         return (
             <Step
                 stepComponent={this}
                 stepNum={this.stepNum}
                 stepBody={this.body()}
             />
         );
     }
 }
 
 export default Step4;